import angular from 'angular';
import constants from 'app/constants';
import {
  loaderService,
  ssDialogService,
  vmDataService,
} from 'app/services';
import {
  alerts,
  confirmDialog,
} from 'app/components/global';
import performControlsReviewDialog from '../dialog.performControlsReviewDialog';
import completeControlReviewWithNoControlsDialog from '../dialog.completeControlReviewWithNoControlsDialog';
import controller from './confirm-controls-review-dialog.controller';
import template from './confirm-controls-review-dialog.html';


class dialogService {
  getOptions($event, { vendor, product, currentControlsReviewTask }) {
    return {
      controller,
      controllerAs: 'confirmControlsReviewDialogVM',
      locals: {
        vendor,
        product,
        currentControlsReviewTask
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.vendorManagement.confirmControlsReviewDialog', [
  alerts,
  confirmDialog,
  constants,
  loaderService,
  ssDialogService,
  vmDataService,
  performControlsReviewDialog,
  completeControlReviewWithNoControlsDialog,
])
  .service('confirmControlsReviewDialog', dialogService)
  .name;
